import gql from 'graphql-tag';

const REMOVE_INVESTMENT_INTENT = gql`
    mutation removeInvestmentIntent(
        $investmentIntentId: String!
    ) {
        removeInvestmentIntent(
            removeInvestmentInput: {
                investmentIntentId: $investmentIntentId
            }
        ) {
            id
            poolId
            amount
        }
    }
`

export default REMOVE_INVESTMENT_INTENT;